import React from 'react';
const StarIcon = () => <svg className="w-3 h-3 fill-current" viewBox="0 0 24 24" data-id="element-80">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-81" />
  </svg>;
export function HeroSection() {
  return <section className="w-full px-4 py-6 md:py-10 max-w-7xl mx-auto" data-id="element-82">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-center" data-id="element-83">
        <div className="flex flex-col space-y-3" data-id="element-84">
          <p className="text-xs md:text-sm text-text-muted font-medium uppercase tracking-wider" data-id="element-85">
            Para vos que ya lo intentaste todo
          </p>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-text-main" data-id="element-86">
            Seguís volviendo al mismo lugar. No es tu culpa. Es un patrón. Y se
            rompe.
          </h1>
          <p className="text-sm md:text-base text-text-muted font-medium leading-snug" data-id="element-87">
            <strong className="text-text-main" data-id="element-88">
              3 sistemas completos + 100 preguntas terapéuticas guiadas
            </strong>{' '}
            · Acceso inmediato · Funciona aunque ya lo intentaste todo
          </p>

          <a href="https://tulibrodigital.lat/cart/51414367928544:1?checkout" onClick={() => {
          const w = window as any;
          w.fbq && w.fbq('track', 'AddToCart');
        }} className="block w-full text-center bg-accent text-white font-bold text-lg py-3 px-6 rounded-xl shadow-md active:scale-95 transition-transform" data-id="element-89">
            QUIERO SALIR DE ESTE CICLO — ACCEDER AHORA
          </a>

          <div className="flex flex-wrap items-center gap-3 text-xs text-text-muted font-medium" data-id="element-90">
            <div className="flex items-center text-bonus" data-id="element-91">
              {[...Array(5)].map((_, i) => <StarIcon key={i} data-id="element-92" />)}
            </div>
            <div className="flex items-center gap-1" data-id="element-93">
              <svg className="w-3 h-3 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-94">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-95" />
                <path d="m9 12 2 2 4-4" data-id="element-96" />
              </svg>
              <span data-id="element-97">Compra Verificada</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-98">
              <svg className="w-3 h-3 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-99">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" data-id="element-100" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-101" />
              </svg>
              <span data-id="element-102">Pago Seguro</span>
            </div>
          </div>
        </div>

        <div className="relative w-full aspect-[4/3] md:aspect-[4/5] bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100" data-id="element-103">
          <img src="https://cdn.magicpatterns.com/uploads/xeNGsksoXTnGTAiPV1VseT/20260408_2133_Image_Generation_simple_compose_01knqtfjq1egxt7ykr1d03y4tj_(1).webp" alt="Sistema de Sanación Emocional Integral" className="absolute inset-0 w-full h-full object-cover" data-id="element-104" />
        </div>
      </div>
    </section>;
}